import { createSlice } from '@reduxjs/toolkit';
import { CheckCircleOutlineIcon, CircleCloseIcon } from '@src/svg';
import { documentsApi } from '@store/rtk/documents';
import { TableData } from '@uikit/Tables/types';
import { beautifyDateTime } from '@src/utils';
import { surveysConfigs } from './configs';
import { TABLE_COLUMNS } from '@uikit/Tables/columns';

type SurveysSliceType = {
  surveyTemplateData: TableData;
  surveysData: TableData;
};

const { surveyTemplateColumns, surveysColumns } = TABLE_COLUMNS;

const initialState: SurveysSliceType = {
  surveyTemplateData: {
    columns: surveyTemplateColumns,
    rows: [],
    size: 5,
  },
  surveysData: {
    columns: surveysColumns,
    rows: [],
    size: 5,
  },
};

const surveysSlice = createSlice({
  name: 'surveys',
  initialState,
  reducers: {
    // Define reducers here
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      documentsApi.endpoints.getSurveys.matchFulfilled,
      (state, { payload }) => {
        if (payload.content && Array.isArray(payload.content)) {
          state.surveysData = {
            ...state.surveysData,
            rows: [
              ...payload.content.map((el, idx) => ({
                ...el,
                id: el.id ? el.id : idx,
                sent: beautifyDateTime(el?.sendingDate),
                effectiveDate: beautifyDateTime(el?.effectiveDate),
                expirationDate: beautifyDateTime(el?.expirationDate),
                sentTo: el?.sendTo ?? '',
                status: el?.status ?? '',
                surveyName: el?.template ?? '',
                signed: Boolean(el?.status === 'Signed') ? (
                  <CheckCircleOutlineIcon />
                ) : (
                  <CircleCloseIcon />
                ),
              })),
            ],
            ...surveysConfigs,
            ...payload,
            requestTablePageChange: documentsApi.endpoints.getSurveys,
          };
        } else if (Array.isArray(payload)) {
          state.surveysData.rows = [
            ...payload.map((el, idx) => ({
              ...el,
              id: el.id ? el.id : idx,
              sent: el.authorizedContact?.firstName,
              sentTo: el.authorizedContact?.email,
              surveyName: el.authorizedContact?.jobTitle,
              effectiveDate: beautifyDateTime(el?.effectiveDate),
              expirationDate: beautifyDateTime(el?.expirationDate),
              status: el.statusId,
            })),
          ];
        } else {
          state.surveysData.rows = [];
        }
      }
    );
    builder.addMatcher(
      documentsApi.endpoints.getSurveyTemplate.matchFulfilled,
      (state, { payload }) => {
        if (payload.content && Array.isArray(payload.content)) {
          state.surveyTemplateData = {
            ...state.surveyTemplateData,
            rows: [
              ...payload.content.map((el, idx) => ({
                ...el,
                id: el.id ? el.id : idx,
                templateName: el?.name,
                description: el?.description,
              })),
            ],
            last: payload.last,
            page: payload.page,
            size: payload.size,
            totalElements: payload.totalElements,
            totalPages: payload.totalPages,
            table: payload.table,
            requestTablePageChange: documentsApi.endpoints.getSurveyTemplate,
          };
        }
      }
    );
  },
});

export const selectSurveys = (state: { surveys: SurveysSliceType }) =>
  state.surveys;
export const {} = surveysSlice.actions;
export const surveysReducer = surveysSlice.reducer;
